import { Component } from '@angular/core';
import { MensIntimateWashComponent } from '@components/consultation-request/upsells/mens-intimate-wash/mens-intimate-wash.component';

@Component({
  selector: 'app-mens-intimate-wash-metformin',
  imports: [MensIntimateWashComponent],
  templateUrl: './mens-intimate-wash-metformin.component.html',
})
export class MensIntimateWashMetforminComponent {}
